import { Stage } from "./Stage"
import { EnrollmentUpload } from "../EnrollmentUpload"
import { Users } from "lucide-react"
import { APCMState } from "../../types/apcm-ops.types"

interface Props {
  orgId: string
  stateCounts: Record<string, number>
  onRefresh: () => void
}

export function EnrollmentStage({ orgId, stateCounts, onRefresh }: Props) {
  const enrolled = stateCounts[APCMState.ENROLLMENT_CONFIRMED] || 0

  return (
    <Stage
      number={1}
      accent="enrollment"
      icon={Users}
      title="Enrollment"
      description="Import patients from an enrollment CSV or spreadsheet."
      total={enrolled}
    >
      <EnrollmentUpload orgId={orgId} onComplete={onRefresh} />
      <p className="text-xs text-muted-foreground">
        Patients appear in <span className="font-semibold">ENROLLMENT_CONFIRMED</span> after upload,
        then move to Consent when outreach is initiated.
      </p>
    </Stage>
  )
}
